import { render, staticRenderFns } from "./favorite-item.vue?vue&type=template&id=580a3d5a"
import script from "./favorite-item.vue?vue&type=script&lang=js"
export * from "./favorite-item.vue?vue&type=script&lang=js"
import style0 from "./favorite-item.vue?vue&type=style&index=0&id=580a3d5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports